/*
 * /songs/$userSongId (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { useTranslation } from "react-i18next"
import { UserSongDetail } from "../../features/songs/components/user-song-detail"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/songs/$userSongId")({
	component: UserSongPage,
	loader: authPageLoader,
})

function UserSongPage() {
	const { t } = useTranslation()
	const { user } = Route.useLoaderData()
	const { userSongId } = Route.useParams()

	const { data: userSong } = trpc.userSong.getByFilter.useQuery({
		where: { id: userSongId },
	})

	const { data: song } = trpc.song.getByFilter.useQuery(
		{ where: { id: userSong?.songId ?? "" } },
		{ enabled: Boolean(userSong?.songId) },
	)

	const title = song
		? `${song.artist} — ${song.title}`
		: t("features.songs.search.addSong")

	return (
		<Page centerVertical={false}>
			<Container width={"xxxl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={title}
					left={{
						href: "/songs",
						label: t("features.songs.title"),
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<UserSongDetail
					id={userSongId}
					userSong={userSong || undefined}
					song={song || undefined}
					user={user}
				/>
			</Container>
		</Page>
	)
}
